import { useEffect, useMemo, useState } from "react";


export function useConfirmacaoDocumentos({ topico, questoes }) {
  const [docsJaConfirmados, setDocsJaConfirmados] = useState(false);

  const isTopicoConfirmavel = topico?.topico === "01";

  const todosTemUpload = useMemo(() => {
    if (!Array.isArray(questoes) || questoes.length === 0) return false;

    return questoes.every(
      (item) =>
        item.document_path &&
        item.document_ativo !== false &&
        !item.document_data_hora_cancel
    );
  }, [questoes]);

  // ✅ REGRA POR TÓPICO (frontend)
  const todosDocsConfirmados = useMemo(() => {
    if (!Array.isArray(questoes) || questoes.length === 0) return false;

    return questoes.every(
      (item) => Boolean(item.file_manager_control?.document_ok)
    );
  }, [questoes]);

  // sincroniza estado
  useEffect(() => {
    if (isTopicoConfirmavel && todosDocsConfirmados) {
      setDocsJaConfirmados(true);
    }
  }, [isTopicoConfirmavel, todosDocsConfirmados]);
  const podeConfirmar =
    isTopicoConfirmavel &&     // tópico 01
    questoes.length > 0 &&     // tópico inicializado
    todosTemUpload &&          // todos os uploads feitos
    !todosDocsConfirmados &&   // backend ainda não confirmou
    !docsJaConfirmados;        // UX imediata

  return {
    podeConfirmar,
    docsJaConfirmados,
    setDocsJaConfirmados, // UX imediata
  };
}